module.exports = __webpack_public_path__ + "img/text_congratulations.fc69d2cc.svg";